<template>
  <el-dialog title="签署人选择" :visible.sync="visible" :show-close="false" v-loading="loading">
    <el-form label-position="left" label-width="150px">
      <el-form-item label="签署方类型">
        <el-radio-group v-model="signer_type">
          <el-radio :label="0">个人</el-radio>
          <el-radio :label="1">公司</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="签署人">
        <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
          <el-option v-for="contact in contacts" :key="contact.id" 
          :label="contact.name + '(' + restricted_mobile(contact.mobile) + ')'" 
          :value="contact.mobile"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="signer_type === 1" label="签署方公司名称">
        <el-select placeholder="请选择签署方公司名称" filterable remote reserve-keyword :loading="org_loading"
                  :remote-method="remoteSearch" v-model="signer_org_name" class="w-75">
          <el-option v-for="org in org_list" :key="org.id" :label="org.name" :value="org.name"></el-option>
        </el-select>
      </el-form-item>
      <el-table ref="fileTable"
                :data="attachments"
                stripe=""
                fit
                highlight-current-row
                class="w-100"
                @select="handleSelection"
                @select-all="handleSelectionAll">
        <el-table-column type="selection"></el-table-column>
        <!-- 文件名称 -->
        <el-table-column align="left" label="文件名称">
          <template slot-scope="scope">
            <span class="text-link" v-preview="scope.row.url" :alt="scope.row.name"
                                  preview-title-enable="true"
                                  preview-nav-enable="true"
                                  v-show="!isPdfFile(scope.row.name)">{{scope.row.name}}</span>
            <span class="text-link" @click="previewPdf(scope.row)"
                  v-show="isPdfFile(scope.row.name)" >{{scope.row.name}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button :disabled="!canConfirm" type="primary" @click="handleConfirm">确 定</el-button>
    </div>

    <el-dialog :title="pdfname" :visible.sync="previewVisible">
      <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { fetchCustomerList } from "@/api/customer"
import { isPdfFile } from "@/utils" 
import { fetchAllContacts } from "@/api/contact"
import { signFile, urgeSign, revokeSign, getSignUrl } from '@/api/sign'
import VuePdfPreview from "@/components/VuePdfPreview"

export default {
  name: "SignerSelectionDialog",
  components: {
    VuePdfPreview
  },
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    send_type: {
      type: String,
      default: 'single'
    },
    object_type: {
      type: String,
      default: ''
    }
  },
  computed: {
    canConfirm() {
      return this.signer_mobile !== ''
    }
  },
  data() {
    return {
      signer_type: 0,
      signer_mobile: '',
      signer_org_name: '',
      org_loading: false,
      org_list: [],
      file: {},
      visible: false,
      loading: false,
      previewVisible: false,
      pdfname: '',
      pdfUrl: '',
      contacts: []
    }
  },
  watch: {
    // 当对话框关闭时重置表单
    visible(newVal) {
      if (!newVal) {
        this.resetForm()
      }
    }
  },
  methods: {
    isPdfFile,
    restricted_mobile(mobile) {
      if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
        let value = mobile.slice(0, 3)
        var l = mobile.slice(3, 7).length
        for (var i=0; i<l; i++) {
          value += '*'
        }
        value += mobile.slice(7)
        return value
      }
      return mobile
    },
    remoteSearch(search) {
      if (search !== '') {
        this.org_loading = true
        fetchCustomerList({search: search, type: '0'})
          .then(res => {
            this.org_list = Object.assign([], res)
            this.org_loading = false
          })
          .catch(error => {
            this.org_loading = false
            this.$error_message(error)
          })
      } else {
        this.org_list = []
      }
    },
    handleSelection(selection) {
      this.attachments.forEach(file => {
        let selected = selection.find(item => {
          return (item.id === file.id)
        })
        if (selected) {
          this.$set(file, 'checked', true)
        } else {
          this.$set(file, 'checked', false)
        }
      })
      // 向父组件通知选择变更
      this.$emit('selection-change', this.attachments.filter(f => f.checked))
    },
    handleSelectionAll(selection) {
      this.attachments.forEach(file => {
        let selected = selection.find(item => {
          return (item.id === file.id)
        })
        if (selected) {
          this.$set(file, 'checked', true)
        } else {
          this.$set(file, 'checked', false)
        }
      })
      // 向父组件通知选择变更
      this.$emit('selection-change', this.attachments.filter(f => f.checked))
    },
    handleCancel() {
      this.visible = false
      this.signer_mobile = ''
      this.file = {}
      this.$emit('cancel')
    },
    handleConfirm() {
        var check_num = 0
        for (let file of this.attachments) {
            if (file.checked) {
            check_num += 1
            }
        }
        if (check_num > 50) {
            this.$error_message("附件上限为50个")
            return
        }

        var text = ''
        if (this.send_type === 'single') {
            console.log("单一签署")
            text = '是否发送文书至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
        }
        else if (this.send_type === 'multiple') {
            console.log("批量签署")
            text = '是否批量发送文书至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
        }

        console.log(this.file)
        this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.$set(this.file, 'signer_mobile', this.signer_mobile)
            this.$set(this.file, 'file_type', this.object_type)
            this.$set(this.file, 'send_type', this.send_type)
            this.$set(this.file, 'signer_type', this.signer_type)
            this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')
            this.$set(this.file, 'policy_table_file_list', this.attachments)
            this.loading = true
            signFile(this.file)
            .then(res => {
                this.loading = false
                this.$message({
                    type: 'success',
                    message: '已通知手机号为: ' + this.restricted_mobile(this.signer_mobile) + ' 的客户进行签署'
                });

                // 向父组件传递签署信息
                  this.$emit('confirm', {
                    result: true,
                    signer_type: this.signer_type,
                    signer_mobile: this.signer_mobile,
                    signer_org_name: this.signer_type === 1 ? this.signer_org_name : '',
                    selected_files: this.attachments.filter(f => f.checked)
                  })
            })
            .catch((err) => {
                this.loading = false
                this.$message.error({
                    message: err
                });
                this.$emit('confirm', {
                    result: false
                })
            })

            this.visible = false
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '取消发送签署'
            });
        });
    },
    previewPdf(file){
      this.pdfname = file.name
      this.pdfUrl = file.url
      this.previewVisible = true
    },
    resetForm() {
      this.signer_type = 0
      this.signer_mobile = ''
      this.signer_org_name = ''
      this.org_list = []
      // 如果需要重置表格选择状态，通过事件通知父组件
      this.$emit('reset-selection')
    },
    showDialog(checked_files) {
      const files = new Array()
      var _index = 0
      var sign_names = []
      var no_file_names = []

      if (checked_files.length === 0) {
        this.$error_message("请选择最少一个签署对象")
        return
      }

      checked_files.forEach(item => {
        if (item.file_sign && item.file_sign.length > 0) {
        sign_names.push(item.name)
        }
        else if ((item !== null) && (item.id)) {
        files.push(item)
        }
        else {
        no_file_names.push(item.name)
        _index += 1
        }
      });

      if (sign_names.length > 0) {
        this.$error_message(sign_names.join(",") + " 已发起签署，请勿重复发起")
        return
      }

      if (_index > 0) {
        this.$error_message(no_file_names.join(",") + " 已签署或未生成，请检查")
        return
      }

      fetchAllContacts()
      .then(res => {
        this.contacts = res
        this.visible = true
        this.$set(this.file, 'file_list', files)

        this.$nextTick(() => {
            if (this.attachments.length > 0) {
                this.$refs.fileTable.clearSelection()
                this.attachments.forEach(file => {
                this.$set(file, 'checked', true)
                this.$refs.fileTable.toggleRowSelection(file, true)
                })
            }
        })
        })
      .catch(err => {
        this.$error_message(err)
        })
    },
  }
}
</script>